module.exports = __webpack_public_path__ + "img/the-netherlands-blood-diseases-male.24ab4f49.png";